import React, { useState, useEffect } from 'react';
import { Connection, PublicKey } from '@solana/web3.js';
import BackButton from './BackButton';
import TreasuryMetrics from './TreasuryMetrics';
import TreasuryAsset from './TreasuryAsset';
import AntCoinImg from './images/AntCoin.png';

function Treasury({ goBack }) {
  const [selectedItem, setSelectedItem] = useState('treasurymetrics');
  const [tokenData, setTokenData] = useState(null);
  const staticAddress = '4tKrDNTe3oe9pu9izyufU1Rt3Br1YZbUt8dcVkJQV5rP';
  const antCoinMintAddress = '9ukhL22ZnEpKQ3g5nTmHUqAy7DKvrpWVR5Z1njACXR9W';
  const alchemyApiKey = process.env.REACT_APP_ALCHEMY_API_KEY;
  const RPC_URL = `https://solana-mainnet.g.alchemy.com/v2/${alchemyApiKey}`;
  const connection = new Connection(RPC_URL);
  const antCoinWeight = '100%';
  const totalAssets = '1';
  const [antCoinPrice, setAntCoinPrice] = useState('0.0100'); // Default price, update as necessary

  useEffect(() => {
    // fetchTokenData().then(data => setTokenData(data));
    fetchAntCoinPrice(); // Fetch the AntCoin price
  }, []);

  async function fetchAntCoinPrice() {
    const antCoinId = 'kingdom-of-ants-ant-coins'; // Replace this with the actual Coingecko ID for AntCoin
    const url = `https://api.coingecko.com/api/v3/simple/price?ids=${antCoinId}&vs_currencies=usd`;
  
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // Assuming the structure is { antcoin: { usd: currentPrice } }
      const currentPrice = data[antCoinId].usd;
      setAntCoinPrice(currentPrice.toString()); // Update the antCoinPrice state
    } catch (error) {
      console.error("Could not fetch AntCoin price:", error);
    }
  }

  async function fetchTokenData() {
    try {
      const response = await fetch('https://localhost:3001/api/antcoin');
     // const response = await fetch('https://backend.kingdomofants.app/api/antcoin');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error("Could not fetch token data:", error);
    }
  }

  // Utilize Intl.NumberFormat for formatting numbers
  function formatNumber(number) {
    return new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(number);
  }

  // Ensure calculations and formatting are only done when tokenData is available
  let formattedTotalValue = '';
  if (tokenData) {
    const totalValue = parseFloat(antCoinPrice) * parseFloat(tokenData.balance);
    formattedTotalValue = formatNumber(totalValue);
  }

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const getAssetContainerClassName = (item) => {
    return `treasury-asset-container2${selectedItem === item ? ' active-treasuryasset' : ''}`;
  };

  return (
      <section id="nestwars">
        <div className="newui-container">
          <div className="platform-container">
              <div className="inventory-container">
                  <div className="inventory-container-left" id="treasury-left">
                    <div className="treasury-container-left-top">
                    <h2>COINS</h2><button className="treasury-metrics-button" onClick={() => handleItemClick('treasurymetrics')}>TREASURY METRICS</button></div>
                      <div className="treasury-assets-container">
                      <div className={getAssetContainerClassName('treasuryasset')}>
                      <div className="treasury-asset-container" onClick={() => handleItemClick('treasuryasset')}>
                          <img src={AntCoinImg} alt="ANT Coin"/>
                          <div className="asset-text-container2">
                            <h2 id="item-stat-quantity3">ANT COIN $ANTC</h2><p id="item-stat-quantity2">In Treasury</p><p id="item-stat-quantity4">Weight</p></div>
                            <div className="asset-text-container">
                              <p id="item-stat-quantity3">Official currency of the Kingdom of ANTS</p><h2 id="item-stat-quantity22">{tokenData ? formatNumber(tokenData.balance) : 'Loading...'}</h2><h2 id="item-stat-quantity44">{(antCoinWeight)}</h2></div>
                      </div></div>
                      </div>
                  </div>
                  {selectedItem === 'treasurymetrics' && <TreasuryMetrics 
            totalAssets={totalAssets} 
            formattedTotalValue={formattedTotalValue || 'Loading...'} 
            onClose={() => setSelectedItem(null)} 
          />}
          {selectedItem === 'treasuryasset' && <TreasuryAsset 
    antCoinBalance={tokenData ? formatNumber(tokenData.balance) : '0'} 
    antCoinWeight={'100%'} 
    antCoinPrice={antCoinPrice} // Use the updated price here
    formattedTotalValue={formattedTotalValue || 'Loading...'}
    onClose={() => setSelectedItem(null)} 
  />}
              </div>
          </div>
          </div>
      </section>
  );
}

export default Treasury;